import React, { useContext } from "react";

import { Box, Flex, Grid, Inline, Stack, Text } from "@atlaskit/primitives";
import styled from "styled-components";

import Lozenge from "@atlaskit/lozenge";
import { useScreenClass } from "react-grid-system";
import MediaClientImage from "../../../../MediaImage";
import { NoImage } from "../../../../../Icons/NoImage";
import StyledText from "../../../../primitives/StyledText";
import { BannerContext } from "../../../context";
import { AppContext } from "../../../../../../Context";
import { formatPriceWithCurrency } from "../../../../../functions";
import {
  ITEM_STATUS_TO_LOZENGE_APPEARANCE_MAP,
  translateStatus,
} from "../../../../../consts";

const Image = styled.div`
  background: ${({ imageSrc }) => `url("${imageSrc}")`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 80px;
  height: 80px;
`;

function ProductItem({ item }) {
  const {
    count,
    mediaClientConfig,
    hasAvatar,
    status,
    name: originalName,
    layout: { name } = {},
  } = item;

  const { config } = useContext(BannerContext);
  const { currency } = config;
  const { forgeContext: { localeCode } = {} } = useContext(AppContext);

  const screenClass = useScreenClass();
  const isMobile = ["xs", "sm"].includes(screenClass);

  const LayoutComponent = isMobile ? Stack : Inline;

  return (
    <Grid templateColumns="80px auto" columnGap="space.200" alignItems="center">
      <MediaClientImage
        height={80}
        width={80}
        mediaClientConfig={mediaClientConfig}
        hasImage={hasAvatar}
        component={(src) => <Image imageSrc={src} />}
        noImageComponent={
          <Box
            style={{
              width: "80px",
              height: "80px",
              display: "grid",
              placeContent: "center",
            }}
          >
            <NoImage />
          </Box>
        }
      />

      <Flex
        columnGap="space.200"
        alignItems="start"
        justifyContent="space-between"
      >
        <Stack space="space.100" alignInline="start">
          <LayoutComponent alignBlock="center" space="space.100">
            <StyledText
              color="color.text.brand"
              customStyles={{ fontWeight: "600" }}
              maxLines={isMobile ? 2 : 1}
            >
              {name || originalName || ""}
            </StyledText>
            {item.status && (
              <Lozenge
                appearance={ITEM_STATUS_TO_LOZENGE_APPEARANCE_MAP[item.status]}
              >
                {translateStatus(item.status)}
              </Lozenge>
            )}
          </LayoutComponent>

          <StyledText
            customStyles={{
              fontSize: "16px",
              lineHeight: "20px",
              fontWeight: "600",
            }}
          >
            {count}x
          </StyledText>
        </Stack>
        <StyledText customStyles={{ fontWeight: "600" }}>
          {formatPriceWithCurrency({
            price: Number(item?.layout?.price || 0) * count,
            locale: localeCode,
            currency,
          })}
        </StyledText>
      </Flex>
    </Grid>
  );
}

export default ProductItem;
